import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

import logo from '../img/logo.png'

const styles = {
  logo: {
    width: 44,
    marginRight: 5,
  }
}

function Header(props) {
  const { classes } = props

  return (
    <div>
      <AppBar position="static" color="default">
        <Toolbar>
          <img className={classes.logo} src={logo} alt=""></img>
          <Typography variant="h6" color="inherit">
            EPIBYTE
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  )
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Header)
